module.exports = __webpack_public_path__ + "static/img/autumn_lipingPic.ed0c8c0b.png";